import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import capExResWelcomeStyle from "assets/jss/material-kit-pro-react/views/capabilityExplorerResultsPageSections/capExResWelcomeStyle.jsx";
import PDRecommendation from "components/PDRecommendation/PDRecommendation.jsx";

class CapExResRecommendationsSection extends React.Component {

  render() {
    const { classes, recommendations } = this.props;
    const pdrecommendations = this.props.recommendations
      .slice(0, 7)
      .map(item => {
        return (
          <GridItem xs={12} sm={12} md={12} key={item.id}>
            <PDRecommendation
              key={item.id}
              id={item.id}
              domain={item.domain}
              pdname={item.pdname}
              pdlink={item.pdlink}
              score={item.score}
            />
          </GridItem>
        );
    });
    return (
      <div className={classes.section}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={10}>
            <h2 className={classes.title}>PD Recommendations</h2>
            <h5 className={classes.description}>
              These are the top 7 PD recommendations, based on your results.
              {/* <pre>{JSON.stringify(this.props.recommendations, null, 4)}</pre> */}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer
          direction="column"
          justify="flex-start"
          alignItems="flex-start"
        >
          {pdrecommendations}
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(capExResWelcomeStyle)(CapExResRecommendationsSection);
